import React, { useState } from 'react';
import SelkirkIcon from '../icons/SelkirkIcon';
import './Tabs.css';

/**
 * Tabs Component
 * Simple tabbed interface for organizing content
 * 
 * @param {Object} props
 * @param {Array} props.tabs - Array of tab objects: [{ id, label, content }]
 * @param {string} props.defaultTab - ID of the tab to show by default
 * @param {Function} props.onTabChange - Callback when tab changes
 */
const Tabs = ({ tabs, defaultTab, onTabChange, className = '' }) => {
  const [activeTab, setActiveTab] = useState(defaultTab || tabs[0]?.id);

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    if (onTabChange) {
      onTabChange(tabId);
    }
  };

  const activeTabContent = tabs.find(tab => tab.id === activeTab)?.content;

  return (
    <div className={`tabs-container ${className}`}>
      {/* Tab Headers */}
      <div className="tabs-header">
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => handleTabClick(tab.id)}
            disabled={tab.disabled}
          >
            {(tab.iconId || tab.icon) && (
              <span className="tab-icon">
                {tab.iconId ? (
                  <SelkirkIcon name={tab.iconId} variant="nav" decorative />
                ) : (
                  tab.icon
                )}
              </span>
            )}
            <span className="tab-label">{tab.label}</span>
            {tab.badge && <span className="tab-badge">{tab.badge}</span>}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="tabs-content">
        {activeTabContent}
      </div>
    </div>
  );
};

export default Tabs;

